import { editorPicks, posts } from "@/mocks/posts";
import PostCard from "@/components/feature/PostCard";
import HotRanking from "@/components/feature/HotRanking";

export default function TrendingSection() {
  const picks = posts.filter((p) => editorPicks.includes(p.id));

  return (
    <section className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-1">
            <HotRanking limit={5} />
            <div className="mt-5 p-5 rounded-lg border border-accent-200 bg-accent-50">
              <h3 className="font-heading font-bold text-base text-accent-900 flex items-center gap-2">
                <i className="ri-lightbulb-flash-line" aria-hidden="true"></i>
                看瓜小提示
              </h3>
              <p className="mt-2.5 text-sm text-accent-800 leading-relaxed">
                网络话题变化很快，看到尚未证实的说法时，可以先留意文中的信息标注，再等等后续进展。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-5">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">编辑精选</h2>
              <span className="text-xs text-foreground-500">由编辑团队人工挑选</span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {picks.map((post) => (
                <PostCard key={post.id} post={post} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}